import React, { useState } from "react";
import { useCart } from "../context/CartContext";

const CartSidebar = () => {
  const { cartItems, removeFromCart, totalPrice } = useCart();
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed right-5 bottom-5 z-50">
      <button
        onClick={() => setOpen(!open)}
        className="bg-lime-400 text-black font-bold px-5 py-3 rounded-full shadow-lg hover:bg-lime-300"
      >
        🛒 Košík ({cartItems.length})
      </button>

      {open && (
        <div className="absolute bottom-16 right-0 bg-neutral-900 text-white p-4 rounded-2xl w-80 shadow-xl border border-lime-400">
          <h3 className="text-lg font-semibold mb-2">Tvoje poptávka</h3>
          {cartItems.length === 0 ? (
            <p>Košík je prázdný</p>
          ) : (
            <>
              {cartItems.map((item) => (
                <div
                  key={item.sku}
                  className="border-b border-gray-700 py-2 flex justify-between items-center"
                >
                  <div>
                    <p className="font-semibold text-sm">{item.name}</p>
                    <p className="text-xs">{item.quantity}× {item.package}</p>
                  </div>
                  <button
                    onClick={() => removeFromCart(item.sku)}
                    className="text-red-400 text-xs hover:underline"
                  >
                    Odebrat
                  </button>
                </div>
              ))}
              <div className="mt-3 text-right font-semibold">
                Celkem: {totalPrice.toFixed(2)} Kč s DPH
              </div>
              <a
                href="/cart"
                className="block text-center mt-3 bg-lime-400 text-black font-bold py-2 rounded-lg hover:bg-lime-300"
              >
                Přejít k poptávce →
              </a>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default CartSidebar;
